import {
    type FC
} from "react";
import type IComposerInputProps from "./type";
import {
    warnOnce
} from "../../../../utils/development";

const ComposerInput: FC<IComposerInputProps> = () => {
    warnOnce({
        message: "Composer.Input: render it as a direct child of Composer; it only configures the text area."
    });

    return null;
};
export default ComposerInput;
